import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
import leftimgs from "../../assets/spaceScienceLeftImg.png";
import rightimgs from "../../assets/spaceScienceRightImg.png";
// import astronout from "../../assets/astronout.png";
// import CourseExplorer from "../../MyComponents/CourseExplorer";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";
import HeadSection from "../HeadSection.js";
import pencilIcon from "../../assets/pencil.png";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Link } from "react-router-dom";
import API_CONFIG from "../../config/api";
import img1 from "../../assets/Space Sciences/Group 22.png"
import icon1 from "../../assets/Space Sciences/maki_rocket.png"
const courses = [
  {
    title: "Astronomy",
    image: img1,
    icon: icon1,
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/space_sc_atronomy"
  }

];



const SpacePopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <div className="stem-container">
      <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
      <h1 className="stem-title">Space Science Courses</h1>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.title} className="course-card">
            <Link to={course.link} className="course-link">

              <div className="course-image-container">
                <img
                  src={course.image}
                  alt={course.title}
                  className="course-image"
                />
                <span className="ages-badge">{course.age}</span>
              </div>

              <div className="icon-container" style={{ backgroundColor: course.color }}>
                <img src={course.icon} alt={`${course.title} icon`} className="course-icon" />
              </div>

              <p className="course-title">{course.title}</p>
            </Link>
          </div>
        ))}
      </div>
      <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
        <img src={`${API_CONFIG.IMAGES_URL}/Polymath-images/pencil.png`} alt="icon" className="pobtn-icon" />
        Book Free Demo Class
      </button>
    </div>
  );
};
const SpaceSciencesPortal = () => {
  const sciencepage = heroContent.sciencepage;
  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={`Polymath-images/spaceScienceLeftImg.png`}
        rightImg={`Polymath-images/spaceScienceRightImg.png`}
        titlePart1="Journey Through Space"
        titlePart2="with Polymath-Kids"
        description="Exploring space has always captured the curiosity of young minds. From learning about the origins of the universe to discovering new planets, the field of space sciences offers endless opportunities for learning and wonder."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/pencil.png'}
        button2Icon={'Polymath-images/pencil.png'}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />

      <SpacePopularCourses />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default SpaceSciencesPortal;
